<div class="g-layout__container" [dir]="dir" style="background-color: #f9fafb; padding: 0.75rem;">

    <!-- TABS NAVIGATION -->
    <section class="dashboard-tabs-container">
      <div class="tabs-wrapper">
        <button 
          *ngFor="let tab of dashboardTabs" 
          class="tab-button"
          [class.active]="activeTab === tab.id"
          (click)="switchTab(tab.id)">
          <i [class]="tab.icon"></i>
          <span>{{ tab.label }}</span>
        </button>
      </div>
    </section>
  
    <!-- TAB CONTENT -->
    <section class="tab-content">
      
      <!-- TAB 1: نظرة عامة (Overview) - Current Charts -->
      <div *ngIf="activeTab === 'overview'" class="dashboard-grid">
  
      <!-- TOP ROW -->
      <!-- 1. Indicator Weights (Small) -->
      <div class="card card--sm" (click)="openChartModal(indicatorWeightsOptions, 'indicator_importance_by_weight')">
        <div class="card__body">
          <h3 class="card__title">{{ 'indicator_importance_by_weight' | translate }}</h3>
          <div echarts [options]="indicatorWeightsOptions" class="chart-fill"></div>
        </div>
      </div>
  
      <!-- 2. Progress Trend (Large - spans 2 columns) -->
      <div class="card card--wide" (click)="openChartModal(progressTrendChartOptions, 'strategic_initiatives_progress_trend')">
        <div class="card__body">
          <h3 class="card__title">{{ 'strategic_initiatives_progress_trend' | translate }}</h3>
          <div echarts [options]="progressTrendChartOptions" class="chart-fill"></div>
        </div>
      </div>
  
      <!-- BOTTOM ROW -->
      <!-- 3. Top Performing Indicators (Semi-circle donut) -->
      <div class="card card--md" (click)="openChartModal(topIndicatorsPieOptions, 'top_performing_indicators')">
        <div class="card__body">
          <h3 class="card__title">{{ 'top_performing_indicators' | translate }}</h3>
          <div echarts [options]="topIndicatorsPieOptions" class="chart-fill"></div>
        </div>
      </div>
  
      <!-- 4. Strategic Indicators Performance Ratios (Circular donut) -->
      <div class="card card--md" (click)="openChartModal(IndicatorClassificationChartOptions, 'strategic_indicators_performance_ratios')">
        <div class="card__body">
          <h3 class="card__title">{{ 'strategic_indicators_performance_ratios' | translate }}</h3>
          <div echarts [options]="IndicatorClassificationChartOptions" class="chart-fill"></div>
        </div>
      </div>

      <!-- 5. Number of Initiatives at Department Level (Horizontal bar) -->
      <div class="card card--md" (click)="openChartModal(chartOptions, 'initiatives_by_department')">
        <div class="card__body">
          <h3 class="card__title">{{ 'initiatives_by_department' | translate }}</h3>
          <div echarts [options]="chartOptions" class="chart-fill"></div>
        </div>
      </div>

      </div>
      
      <!-- TAB 2: أداء الإدارات (Department Performance) -->
      <div *ngIf="activeTab === 'departments'" class="tab-panel">
        <!-- Department KPI Cards -->
        <div class="kpi-grid">
          <div *ngFor="let kpi of departmentKPIs; trackBy: trackByKpiLabel" class="kpi-card">
            <div class="kpi-icon" [style.background]="kpi.color">
              <i [class]="kpi.icon"></i>
            </div>
            <div class="kpi-content">
              <h3>{{ kpi.label | translate }}</h3>
              <div class="kpi-value">
                <span [countUp]="parseKpiValue(kpi.value)" [duration]="2000"></span>{{ getKpiSuffix(kpi.value) }}
              </div>
            </div>
          </div>
        </div>
        
        <!-- Department Charts Grid - 3 cards in one row -->
        <div class="dashboard-grid mt-4">
          <div class="card card--md" (click)="openChartModal(chartOptions, 'initiatives_by_department')">
            <div class="card__body">
              <h3 class="card__title">{{ 'initiatives_by_department' | translate }}</h3>
              <div echarts [options]="chartOptions" class="chart-fill"></div>
            </div>
          </div>
          
          <div class="card card--md" (click)="openChartModal(departmentWorkloadChartOptions, 'department_workload_distribution')">
            <div class="card__body">
              <h3 class="card__title">{{ 'department_workload_distribution' | translate }}</h3>
              <div echarts [options]="departmentWorkloadChartOptions" class="chart-fill"></div>
            </div>
          </div>
          
          <div class="card card--md" (click)="openChartModal(departmentTrendChartOptions, 'department_progress_trend')">
            <div class="card__body">
              <h3 class="card__title">{{ 'department_progress_trend' | translate }}</h3>
              <div echarts [options]="departmentTrendChartOptions" class="chart-fill"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- TAB 3: المشاريع الاستراتيجية (Strategic Projects) -->
      <div *ngIf="activeTab === 'projects'" class="tab-panel">
        <!-- Project KPI Cards -->
        <div class="kpi-grid">
          <div *ngFor="let kpi of projectKPIs; trackBy: trackByKpiLabel" class="kpi-card">
            <div class="kpi-icon" [style.background]="kpi.color">
              <i [class]="kpi.icon"></i>
            </div>
            <div class="kpi-content">
              <h3>{{ kpi.label | translate }}</h3>
              <div class="kpi-value">
                <span [countUp]="parseKpiValue(kpi.value)" [duration]="2000"></span>{{ getKpiSuffix(kpi.value) }}
              </div>
            </div>
          </div>
        </div>
        
        <!-- Project Charts -->
        <div class="dashboard-grid mt-4">
          <div class="card card--md" (click)="openChartModal(pie_options, 'project_status_distribution')">
            <div class="card__body">
              <h3 class="card__title">{{ 'project_status_distribution' | translate }}</h3>
              <div echarts [options]="pie_options" class="chart-fill"></div>
            </div>
          </div>
          
          <div class="card card--md" (click)="openChartModal(projectBudgetChartOptions, 'project_budget_allocation')">
            <div class="card__body">
              <h3 class="card__title">{{ 'project_budget_allocation' | translate }}</h3>
              <div echarts [options]="projectBudgetChartOptions" class="chart-fill"></div>
            </div>
          </div>
          
          <div class="card card--md" (click)="openChartModal(projectFunnelChartOptions, 'project_completion_funnel')">
            <div class="card__body">
              <h3 class="card__title">{{ 'project_completion_funnel' | translate }}</h3>
              <div echarts [options]="projectFunnelChartOptions" class="chart-fill"></div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- TAB 3: الأثر والتنافسية (Impact & Competitiveness) -->
      <div *ngIf="activeTab === 'impact'" class="tab-panel">
        <!-- Impact KPI Cards -->
        <div class="kpi-grid">
          <div *ngFor="let kpi of impactKPIs; trackBy: trackByKpiLabel" class="kpi-card">
            <div class="kpi-icon" [style.background]="kpi.color">
              <i [class]="kpi.icon"></i>
            </div>
            <div class="kpi-content">
              <h3>{{ kpi.label | translate }}</h3>
              <div class="kpi-value">
                <span [countUp]="parseKpiValue(kpi.value)" [duration]="2000"></span>{{ getKpiSuffix(kpi.value) }}
              </div>
            </div>
          </div>
        </div>
        
        <!-- Impact Charts -->
        <div class="dashboard-grid mt-4">
          <div class="card card--md" (click)="openChartModal(riskChartOptions, 'risk_assessment')">
            <div class="card__body">
              <h3 class="card__title">{{ 'risk_assessment' | translate }}</h3>
              <div echarts [options]="riskChartOptions" class="chart-fill"></div>
            </div>
          </div>
          
          <div class="card card--md" (click)="openChartModal(competitiveChartOptions, 'competitive_position')">
            <div class="card__body">
              <h3 class="card__title">{{ 'competitive_position' | translate }}</h3>
              <div echarts [options]="competitiveChartOptions" class="chart-fill"></div>
            </div>
          </div>
          
          <div class="card card--md" (click)="openChartModal(riskMitigationChartOptions, 'risk_mitigation_progress')">
            <div class="card__body">
              <h3 class="card__title">{{ 'risk_mitigation_progress' | translate }}</h3>
              <div echarts [options]="riskMitigationChartOptions" class="chart-fill"></div>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  
  </div>
  
  <!-- Modal for Goals/Indicators/Projects -->
  <p-dialog
    [modal]="true"
    [(visible)]="visible"
    [style]="{ width: '80rem', Height:'80rem'}"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true"
  >
    <ng-template pTemplate="header">
      <div class="flex justify-content-between align-items-center flex-row-reverse">
        <div class="font-bold">{{modalHeaderName}}</div>
      </div>
    </ng-template>
  
    <div>
      @switch (selectedModalType) {
        @case("goals"){
          <div class="goals justify-content-evenly grid mt-5 ">
            <app-goals [selectedStrategyId]="selectedStrategyId" [goals]="goals"></app-goals>
          </div>
        }
        @case("indicators"){
          <div class="indicators grid mt-5 justify-content-center ">
            @for(indicator of indicators;track indicator){
              <div class=" lg:col-6 md:col-12 col-12 ">
                <app-shared-indicator
                  [indicator]="indicator"
                  [selectedStrategyId]="selectedStrategyId"
                ></app-shared-indicator>
              </div>
            }
          </div>
        }
        @case("projects"){
          <div class="grid justify-content-center ">
            <app-shared-project
              [projects]="projects"
              [isDeleteAllowed]="false"
              [strategyId]="selectedStrategyId"
            ></app-shared-project>
          </div>
        }
      }
    </div>
  </p-dialog>
  
  <!-- Chart Modal -->
  <p-dialog
    [modal]="true"
    [(visible)]="chartModalVisible"
    [style]="{ width: '85vw', height: '75vh' }"
    [breakpoints]="{ '1199px': '90vw', '575px': '95vw' }"
    [maximizable]="true"
    [dir]="dir"
    [blockScroll]="true"
    appendTo="body"
    (onHide)="closeChartModal()"
  >
    <ng-template pTemplate="header">
      <div class="flex justify-content-between align-items-center w-full">
        <h3 class="font-bold m-0" style="font-family: Cairo;">{{ chartModalTitle }}</h3>
      </div>
    </ng-template>
    
    <div class="chart-modal-content" *ngIf="chartModalVisible && chartModalOptions">
      <div echarts [options]="chartModalOptions" style="height: 60vh; width: 100%; min-height: 500px;"></div>
    </div>
  </p-dialog>
  